"use strict";
////////////////////////////////////////////////
// ChartType
////////////////////////////////////////////////
Object.defineProperty(exports, "__esModule", { value: true });
exports.FunnelChartSettingsJSONModel = exports.ChartType = void 0;
var ChartType;
(function (ChartType) {
    ChartType["classic"] = "classic";
    ChartType["overtime"] = "overtime";
})(ChartType = exports.ChartType || (exports.ChartType = {}));
class FunnelChartSettingsJSONModel {
    constructor(serializedState) {
        this.reset = () => {
            this.resetChartType();
        };
        this.overwriteFromSerializedState = (serializedState) => {
            if (serializedState) {
                this.chartType = validateChartType(serializedState.chartType);
            }
        };
        this.serialize = () => {
            return {
                chartType: this.chartType,
            };
        };
        ////////////////////////////////////////////////
        // ChartType
        ////////////////////////////////////////////////
        this.getChartType = () => this.chartType;
        this.setChartType = (value) => this.chartType = validateChartType(value);
        this.resetChartType = () => this.setChartType(undefined);
        this.reset();
        this.overwriteFromSerializedState(serializedState);
    }
}
exports.FunnelChartSettingsJSONModel = FunnelChartSettingsJSONModel;
const validateChartType = (value) => {
    if (typeof value === "string" && value in ChartType) {
        return value;
    }
    return ChartType.classic;
};
